import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import get from 'lodash/get';
import {
  responsiveImageAlternativeType,
  responsiveImageType,
  responsiveVideoType,
} from '../../propTypes';
import ResponsiveImage from './ResponsiveImage';
import Video from './Video';
import createElementResizeDetectorRef from '../../utils/createElementResizeDetectorRef';

class ImageOrVideo extends PureComponent {
  state = {
    playing: false
  };

  setRef = createElementResizeDetectorRef(({ width, height }) => {
    this.setState({ width, height });
  });

  onVideoPlaying = () => {
    const {onVideoPlaying} = this.props;
    this.setState({playing: true});
    if(onVideoPlaying) {
        onVideoPlaying();
    }
  }

  renderVideo() {
    const { height, width } = this.state;
    if (width !== undefined) {
      const {
        classes, loopVideo, onVideoEnded, onVideoProgress, video, videoCurrentTime,
        videoPaused, link, controls, children
      } = this.props;
      return (
        <Video
          className={cn(classes.video)}
          currentTime={videoCurrentTime}
          loop={loopVideo}
          onEnded={onVideoEnded}
          onPlaying={this.onVideoPlaying}
          onProgress={onVideoProgress}
          paused={videoPaused}
          video={video}
          viewportHeight={height}
          viewportWidth={width}
          link={link}
          controls={controls}
        >{children}</Video>
      );
    }
    return null;
  }

  render() {
    const {
      aspect, classes, className, video, defaultAlt, imageClassName, link,
      onMouseEnter, onMouseLeave, validImages, children
    } = this.props;
    const hasVideo = !!get(video, ['sizes', 'length']);
    const {playing} = this.state;

    return (
      <div className={cn(className, classes.wrapper)} ref={hasVideo ? this.setRef : undefined}>
        <ResponsiveImage
          aspect={aspect}
          className={cn({[classes.imageWithVideo]: hasVideo, hide: playing}, imageClassName)}
          images={validImages}
          link={link}
          alt={get(validImages, ['desktop', 0, 'alt']) || defaultAlt}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        ></ResponsiveImage>
        {hasVideo && this.renderVideo()}
        {children}
      </div>
    );
  }
}

ImageOrVideo.propTypes = {
  aspect: PropTypes.number,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  currentImageAlternative: responsiveImageAlternativeType,
  defaultAlt: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types, used in mapStateToProps
  image: responsiveImageType,
  imageClassName: PropTypes.string,
  loopVideo: PropTypes.bool,
  onVideoEnded: PropTypes.func,
  onVideoPlaying: PropTypes.func,
  onVideoProgress: PropTypes.func,
  validImage: responsiveImageType,
  video: responsiveVideoType,
  videoCurrentTime: PropTypes.number,
  videoPaused: PropTypes.bool,
  controls: PropTypes.bool
};

ImageOrVideo.defaultProps = {
  aspect: undefined,
  className: undefined,
  currentImageAlternative: undefined,
  defaultAlt: undefined,
  image: null,
  imageClassName: undefined,
  loopVideo: true,
  onVideoEnded: undefined,
  onVideoPlaying: undefined,
  onVideoProgress: undefined,
  validImage: undefined,
  video: null,
  videoCurrentTime: 0,
  videoPaused: false,
  controls: false
};

const mapStateToProps = (state, {images, video}) => {
  const validImages = images || get(video, ['image'])
  return {
    validImages
  };
};

export default compose(
  connect(mapStateToProps),

  injectSheet({
    wrapper: {
      position: 'relative',
      overflow: 'hidden',
    },
    video: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      transition: 'opacity 0.4s ease-out'
    },
    imageWithVideo: {
      opacity: 1,
      transition: 'opacity 0.4s ease-out',
      '&.hide': {
        opacity: 0
      }
    }
  }),
)(ImageOrVideo);



// WEBPACK FOOTER //
// ./src/components/Widgets/ImageOrVideo.js